import React, { FC } from 'react';
import { SettingsFormPageSkeleton, SettingsTablePageSkeleton } from '../settings/settingsSkeleton';

export const BackgroundColorRulesPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const BackgroundColorRulePageSkeleton: FC = () => <SettingsFormPageSkeleton />;
